import React from "react";
import { Space, Typography, Card, Row, Col } from "antd";
import PropTypes from "prop-types";

const { Text, Title } = Typography;

const SiteHeader = ({ title, subTitle }) => (
  <div>
    <Space align="center">
      <div>
        <Title level={1} style={{ marginBottom: "0px" }}>
          {title}
        </Title>
        {subTitle && <Text type="primary">{subTitle}</Text>}
      </div>
    </Space>
  </div>
);

SiteHeader.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
};

const PageHeader1 = ({ title, subTitle, icon, search }) => (
  <div
    style={{
      backgroundColor: "#f3f4f5",
      borderBottom: "solid 2px #ccc",
      marginBottom: "10px",
      padding: "5px",
    }}
  >
    <Row align="middle">
      <Col>
        <Space align="center">
          {icon &&
            React.cloneElement(icon, {
              style: { fontSize: "48px", color: "#aaa" },
            })}
          <div>
            <Title level={3} style={{ marginBottom: "0px", marginTop: "0px" }}>
              {title}
            </Title>
            {subTitle && <Text type="default">{subTitle}</Text>}
          </div>
        </Space>
      </Col>
      <Col flex="auto"></Col>
      <Col>
        <Space align="center">{search}</Space>
      </Col>
    </Row>
  </div>
);

PageHeader1.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  icon: PropTypes.element,
  search: PropTypes.element,
};

const PageHeader2 = ({ title, subTitle, icon, search }) => (
  <div
    style={{
      backgroundColor: "#f3f4f5",
      borderBottom: "solid 2px #ccc",
      marginBottom: "10px",
      padding: "5px",
    }}
  >
    <Row align="middle">
      <Col>
        <Space align="center">
          {icon &&
            React.cloneElement(icon, {
              style: { fontSize: "36px", color: "#aaa" },
            })}
          <div>
            <Title level={5} style={{ marginBottom: "0px", marginTop: "0px" }}>
              {title}
            </Title>
            {subTitle && <Text type="default">{subTitle}</Text>}
          </div>
        </Space>
      </Col>
      <Col flex="auto"></Col>
      <Col>
        <Space align="center">{search}</Space>
      </Col>
    </Row>
  </div>
);

PageHeader2.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  icon: PropTypes.element,
  search: PropTypes.element,
};

const ServiceHeader = ({ title, subTitle, loading, button }) => (
  <Card
    style={{
      borderRadius: "8px 8px 0 0",
      color: "white",
      backgroundColor: "#414852",
    }}
    styles={{ body: { paddingTop: "10px", paddingBottom: "10px" } }}
    loading={loading}
  >
    <Title
      style={{ color: "white", marginBottom: "5px", marginTop: "0px" }}
      level={3}
    >
      {title}
    </Title>
    {subTitle && (
      <Text type="secondary" style={{ color: "white" }}>
        {subTitle}
      </Text>
    )}
    {button}
  </Card>
);

ServiceHeader.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  loading: PropTypes.bool,
  button: PropTypes.element,
};

const ApplicationHeader = ({ title, subTitle, button }) => (
  <div style={{ backgroundColor: "#ddd", padding: "5px" }}>
    <Space align="center">
      <Title level={5} style={{ marginTop: "6px" }}>
        {title}
      </Title>
      {button}
      {subTitle && <Text type="secondary">{subTitle}</Text>}
    </Space>
  </div>
);
ApplicationHeader.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  button: PropTypes.element,
};

const ManagedResourceTypeHeader = ({ title, subTitle, button }) => (
  <>
    <div style={{ backgroundColor: "#ddd", padding: "5px" }}>
      <Space align="center">
        {button}
        <Title level={5} style={{ marginTop: "6px" }}>
          {title}
        </Title>
      </Space>
    </div>
    <div>{subTitle && <Text type="secondary">{subTitle}</Text>}</div>
  </>
);

ManagedResourceTypeHeader.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  button: PropTypes.element,
  search: PropTypes.element,
};

export {
  SiteHeader,
  PageHeader1,
  PageHeader2,
  ServiceHeader,
  ApplicationHeader,
  ManagedResourceTypeHeader,
};
